import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=dad6dae0&"
import script from "./AppView.vue?vue&type=script&lang=js&"
export * from "./AppView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports